import BigNumber from 'bignumber.js'
import React, { useState, useEffect, useRef } from 'react';

export function isBig(){
  if(window.innerWidth > 1350)
    return 4;
  return 2;
}
export function preparePrice(price, decimals){
  var res = new BigNumber(price)

  if(isNaN(price))
    return "0.00"
  if(decimals == 8)
  {
    if(Math.abs(res.toNumber()) == 0){
      return "0.00"
    }
    else
      return res.toFormatSpecial(8)
  }
  else{
    return prepareAmount(price)
  }
}

export function sortBalances(balances){
  return Object.keys(balances).sort(function(a,b){
      var a_b = balances[a]
      var b_b = balances[b]
      if(a_b > b_b)
        return -1;
      else if(a_b < b_b)
        return 1;
      return 0
  });
}
export function prepareAmount(price){
  var res = new BigNumber(price)
  if(Math.abs(res.toNumber()) == 0){
    res = "0.00"
  }
  else if(Math.abs(res.toNumber()) < 0.01)
    res = res.toFormatSpecial(6)
  else if(Math.abs(res.toNumber())  < 1){
    res = res.toFormatSpecial(4)
  }
  else{
    res = res.toFormatSpecial(2)
  }
  return res;
}
export const toSignificant = (number, significantDigits = 4) => {
  if(isNaN((number+'').split(',').join(''))){
    return "-"
  }
  BigNumber.set({ FORMAT: {
    prefix: '',
    decimalSeparator: '.',
    groupSeparator: ',',
    groupSize: 3,
    secondaryGroupSize: 0,
    fractionGroupSeparator: ' ',
    fractionGroupSize: 0,
    suffix: ''
  } })
  const updated = new BigNumber((number+'').split(',').join(''))
  var numberDigits = 0
  if(updated.toString(10).split('.').length > 1){
    numberDigits = updated.toString(10).split('.')[1].length

  }

  var res = updated.toFormat(numberDigits)
  if(res.split('.').length > 1){
    var decimalp = res.split('.')[1].split('')
    var index = 0;
    if(Math.abs(parseFloat(res)) < 1){
      for(let c of decimalp){
        if(c != '0'){
          break;
        }
        index+=1;
      }
    }
    res = res.split('.')[0] + "."+res.split('.')[1].slice(0,index+significantDigits)
  }
  var decimalPart = res.split('.')[1]
  if(decimalPart != undefined){
    decimalPart = new BigNumber(decimalPart.split('').reverse().join('')).toString(10).split('').reverse().join('')
    if(decimalPart.length == 1)
      decimalPart += "0"
    if(updated.toNumber() >= 1000000){
      res = res.split('.')[0]
    }
    else if(updated.toNumber() >= 10000){
      res = res.split('.')[0]+"."+decimalPart.slice(0,2);
    }
    else if(updated.toNumber() >= 100){
      res = res.split('.')[0]+"."+decimalPart.slice(0,4);
    }
    else{
      res = res.split('.')[0]+"."+decimalPart
    }
  }
  else{
    if(res.length < 4)
      res = res.replace('.','') + ".00"
  }


  return res
}
